export default 
{
  "items": [
    {
      "id": 50990,
      "titleUrl": "afs-connect-steiger-series",
      "title": "AFS Connect™ Steiger Series",
      "formattedTitle": "AFS Connect Steiger Series",
      "eyebrow": "4WD ROWTRAC",
      "description": "The most powerful 4WD tractor, record-setting fuel efficiency, industry-leading comfort, and the ability to remotely manage your farm, fleet and data with AFS Connect™. All new AFS Connect™ Steiger® tractors come with a five-year AFS Connect technology subscription.",
      "summarySpecs": [
        {
          "key": "Transmission",
          "value": "PowerDrive or CVXDrive"
        },
        {
          "key": "Horsepower",
          "value": "370 - 692 HP"
        },
        {
          "key": "FPT Engine",
          "value": "8.7 / 12.9 L"
        },
        {
          "key": "Hydraulic capacity",
          "value": "Up to 113 gpm"
        }
      ],
      "button1": {
        "label": "Compare Specs",
        "url": "/northamerica/en-us/Pages/Comparison.aspx?family=Tractors&series=202"
      },
      "button2": {
        "label": "Build & Price",
        "url": "/northamerica/en-us/Pages/Build-and-Price-Iframe.aspx?line=TRACTORS"
      },
      "bigthumbnail": "https://corporatei-avanade.stylelabs.io/api/public/content/0f933d17d71f4e8485c8c49ea040923c?v=3cac78e1",
      "bigthumbnailAlt": null,
      "thumbnail": "https://corporatei-p-001-delivery.sitecorecontenthub.cloud/api/public/content/ebe2dac83cc94278921c9654fe6681ef?v=71ea6b8d",
      "thumbnailAlt": null,
      "full": "https://corporatei-p-001-delivery.sitecorecontenthub.cloud/api/public/content/ebe2dac83cc94278921c9654fe6681ef?v=71ea6b8d",
      "fullAlt": null
    },
    {
      "id": 50991,
      "titleUrl": "magnum-series",
      "title": "Magnum Series",
      "formattedTitle": "Magnum Series",
      "eyebrow": "4WD ROWTRAC",
      "description": "The ultimate mix of industry-leading horsepower and fuel efficiency and available in wheel or track configurations. All Model Year 2019 Magnum tractors will include a three-year, 2,000-hour factory warranty.",
      "summarySpecs": [
        {
          "key": "Horsepower",
          "value": "180 - 380 HP"
        },
        {
          "key": "Transmission",
          "value": "PowerDrive or CVXDrive"
        },
        {
          "key": "FPT Engine",
          "value": "6.7 / 8.7 L"
        },
        {
          "key": "Hydraulic capacity",
          "value": "Up to 75 gpm"
        }
      ],
      "button1": {
        "label": "Compare Specs",
        "url": "/northamerica/en-us/Pages/Comparison.aspx?family=Tractors&series=202"
      },
      "button2": {
        "label": "Build & Price",
        "url": "/northamerica/en-us/Pages/Build-and-Price-Iframe.aspx?line=TRACTORS"
      },
      "bigthumbnail": "https://corporatei-p-001-delivery.sitecorecontenthub.cloud/api/public/content/4f51537def474d02ae25ce1c7e751a96?v=88811375",
      "bigthumbnailAlt": null,
      "thumbnail": "https://corporatei-p-001-delivery.sitecorecontenthub.cloud/api/public/content/4f51537def474d02ae25ce1c7e751a96?v=88811375",
      "thumbnailAlt": null,
      "full": "https://corporatei-p-001-delivery.sitecorecontenthub.cloud/api/public/content/4f51537def474d02ae25ce1c7e751a96?v=88811375",
      "fullAlt": null
    },
    {
      "id": 50992,
      "titleUrl": "puma-series",
      "title": "Puma Series",
      "formattedTitle": "Puma Series",
      "eyebrow": "4WD ROWTRAC",
      "description": "An efficient, multipurpose tractor line designed with just the right size and power to handle a variety of tasks in your operation.",
      "summarySpecs": [
        {
          "key": "Horsepower",
          "value": "180 - 380 HP"
        },
        {
          "key": "Transmission",
          "value": "PowerDrive or CVXDrive"
        },
        {
          "key": "FPT Engine",
          "value": "6.7 / 8.7 L"
        },
        {
          "key": "Hydraulic capacity",
          "value": "Up to 75 gpm"
        }
      ],
      "button1": {
        "label": "Compare Specs",
        "url": "/northamerica/en-us/Pages/Comparison.aspx?family=Tractors&series=202"
      },
      "button2": {
        "label": "Build & Price",
        "url": "/northamerica/en-us/Pages/Build-and-Price-Iframe.aspx?line=TRACTORS"
      },
      "bigthumbnail": "https://corporatei-p-001-delivery.sitecorecontenthub.cloud/api/public/content/a4923af5444e45ae84731ff3cbdf41e4?v=c3c27678",
      "bigthumbnailAlt": null,
      "thumbnail": "https://corporatei-p-001-delivery.sitecorecontenthub.cloud/api/public/content/a4923af5444e45ae84731ff3cbdf41e4?v=c3c27678",
      "thumbnailAlt": null,
      "full": "https://corporatei-p-001-delivery.sitecorecontenthub.cloud/api/public/content/a4923af5444e45ae84731ff3cbdf41e4?v=c3c27678",
      "fullAlt": null
    },
    {
      "id": 52272,
      "titleUrl": "preownedtractors",
      "title": "Pre-Owned Tractors",
      "formattedTitle": "Pre-Owned Tractors",
      "eyebrow": "4WD, ROWTRAC & TRACK",
      "description": null,
      "summarySpecs": [],
      "button1": {
        "label": "Compare Specs",
        "url": "/northamerica/en-us/Pages/Comparison.aspx?family=Tractors&series=103"
      },
      "button2": {
        "label": "View Offers",
        "url": "/northamerica/en-us/special-offer-detail?seriesGuid=4ddabf3c-50fb-4447-9304-9ea82d8052f1"
      },
      "bigthumbnail": "https://corporatei-p-001-delivery.sitecorecontenthub.cloud/api/public/content/a1d2f7060a4e446b88b614d3157dee7f?v=d6c998a5",
      "bigthumbnailAlt": null,
      "thumbnail": "https://corporatei-p-001-delivery.sitecorecontenthub.cloud/api/public/content/a1d2f7060a4e446b88b614d3157dee7f?v=d6c998a5",
      "thumbnailAlt": null,
      "full": "https://corporatei-p-001-delivery.sitecorecontenthub.cloud/api/public/content/a1d2f7060a4e446b88b614d3157dee7f?v=d6c998a5",
      "fullAlt": null
    },
    {
      "id": 52299,
      "titleUrl": "magnumseries2014present",
      "title": "Magnum Series (2014-Present)",
      "formattedTitle": "Magnum Series (2014-Present)",
      "eyebrow": "4WD, ROWTRAC & TRACK",
      "description": "This model list for MyCIH use only.",
      "summarySpecs": null,
      "button1": {
        "label": "Compare Specs",
        "url": "/northamerica/en-us/Pages/Comparison.aspx?family=Tractors&series=202"
      },
      "button2": {
        "label": "Build & Price",
        "url": "/northamerica/en-us/Pages/Build-and-Price-Iframe.aspx?line=TRACTORS"
      },
      "bigthumbnail": "https://corporatei-p-001-delivery.sitecorecontenthub.cloud/api/public/content/4f51537def474d02ae25ce1c7e751a96?v=88811375",
      "bigthumbnailAlt": null,
      "thumbnail": "https://corporatei-p-001-delivery.sitecorecontenthub.cloud/api/public/content/4f51537def474d02ae25ce1c7e751a96?v=88811375",
      "thumbnailAlt": null,
      "full": "https://corporatei-p-001-delivery.sitecorecontenthub.cloud/api/public/content/4f51537def474d02ae25ce1c7e751a96?v=88811375",
      "fullAlt": null
    },
    {
      "id": 52302,
      "titleUrl": "pumaseries2014present",
      "title": "Puma Series (2014-Present)",
      "formattedTitle": "Puma Series (2014-Present)",
      "eyebrow": "ALL PURPOSE",
      "description": "This model list for MyCIH use only.\n",
      "summarySpecs": [
        {
          "key": "Transmission",
          "value": "PowerDrive or CVXDrive"
        },
        {
          "key": "Horsepower",
          "value": "370 - 692 HP"
        },
        {
          "key": "FPT engine",
          "value": "8.7 / 12.9 L"
        },
        {
          "key": "Hydraulic Capacity",
          "value": "Up to 113 gpm"
        }
      ],
      "button1": {
        "label": "Learn More",
        "url": "/northamerica/en-us/products/loaders-attachments/l10-series-loaders"
      },
      "button2": null,
      "bigthumbnail": "https://corporatei-p-001-delivery.sitecorecontenthub.cloud/api/public/content/a4923af5444e45ae84731ff3cbdf41e4?v=c3c27678",
      "bigthumbnailAlt": null,
      "thumbnail": "https://corporatei-p-001-delivery.sitecorecontenthub.cloud/api/public/content/a4923af5444e45ae84731ff3cbdf41e4?v=c3c27678",
      "thumbnailAlt": null,
      "full": "https://corporatei-p-001-delivery.sitecorecontenthub.cloud/api/public/content/a4923af5444e45ae84731ff3cbdf41e4?v=c3c27678",
      "fullAlt": null
    },
    {
      "id": 52314,
      "titleUrl": "steigerseries20112013",
      "title": "Steiger Series (2011-2013)",
      "formattedTitle": "Steiger Series (2011-2013)",
      "eyebrow": "ALL PURPOSE",
      "description": "This model list for MyCIH use only.",
      "summarySpecs": [
        {
          "key": "Cutting Widths",
          "value": "25 - 45 ft."
        },
        {
          "key": "Knife Width",
          "value": "3 in."
        },
        {
          "key": "Reel Speed",
          "value": "0 - 60 RPM"
        },
        {
          "key": "Reel Diameter",
          "value": "42 in."
        }
      ],
      "button1": {
        "label": "Compare Specs",
        "url": "/northamerica/en-us/Pages/Comparison.aspx?family=Tractors&series=103"
      },
      "button2": {
        "label": "View Offers",
        "url": "/northamerica/en-us/special-offer-detail?seriesGuid=4ddabf3c-50fb-4447-9304-9ea82d8052f1"
      },
      "bigthumbnail": "https://corporatei-p-001-delivery.sitecorecontenthub.cloud/api/public/content/cc439416dcdd4cb1a67217ca76aaa2e7?v=6332efd8",
      "bigthumbnailAlt": null,
      "thumbnail": "https://corporatei-p-001-delivery.sitecorecontenthub.cloud/api/public/content/cc439416dcdd4cb1a67217ca76aaa2e7?v=6332efd8",
      "thumbnailAlt": null,
      "full": "https://corporatei-p-001-delivery.sitecorecontenthub.cloud/api/public/content/cc439416dcdd4cb1a67217ca76aaa2e7?v=6332efd8",
      "fullAlt": null
    }
  ],
  "total": 7
}